
import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,

} from 'redux-saga/effects'

import {
  get,
  getRequest,
  getWithMeta,
  post,
  del
} from 'helpers/RequestUtil'

import {
  OPEN_DIALOG,
  FETCH_HIERARCHIES,
  FETCH_PROJECTS_SEARCH,
  POST_HIERARCHIES,
  UPDATE_HIERARCHY_TYPE
} from './constants'

import {
  updateHierarchyType,
  updateProjects,
  fetchHierarchies as fetchHierarchiesAction,
  fetchHierarchiesStart,
  fetchHierarchiesSuccess,
  fetchHierarchiesError,
  fetchProjectsSearchStart,
  fetchProjectsSearchSuccess,
  fetchProjectsSearchError,
  updateProjectsSearch,
  postHierarchiesStart,
  postHierarchiesSuccess,
  postHierarchiesError,
  closeDialog
} from './actions'

import {
  overwriteTables,
} from 'containers/Entity/actions'

import { projectIdSelector } from 'containers/Project/View/selectors'

import { hierarchyTypeSourceSelector, projectsSourceSelector, hierarchySelector, projectsSelector } from './selectors'

function* handleOpenDialog(){
    const hierarchyType = yield select(hierarchyTypeSourceSelector)
    const projectsSource = yield select(projectsSourceSelector)
    yield put(updateHierarchyType(hierarchyType))
    yield put(updateProjects(projectsSource))
    yield put(updateProjectsSearch([]))
}

function* handleUpdateHierarchyType({ value }){
  const hierarchyType = yield select(hierarchyTypeSourceSelector)
  const projectsSource = yield select(projectsSourceSelector)
  const projects = value === hierarchyType ? projectsSource : []
  yield put(updateProjects(projects))
}

function* fetchHierarchies({ id }) {
  try {
    yield put(fetchHierarchiesStart())
    const data = yield call(
      get,
      `api/fulcrum/projects/${id}/hierarchy`
    )
    yield put(overwriteTables(data))
    yield put(fetchHierarchiesSuccess())

  } catch(error) {
    console.log(error)
    yield put(fetchHierarchiesError(error))
  }
}

function* fetchProjectsSearch({ query }) {
  const q = yield encodeURIComponent(query)
  if (q === '') return
  try {
    const id = yield select(projectIdSelector)
    const hierarchyType = yield select(hierarchySelector)
    yield put(fetchProjectsSearchStart())
    const { data } = yield call(
      getRequest,
      `api/fulcrum/projects/${id}/hierarchy_search?type=${hierarchyType}&search=${q}`
    )
    yield put(updateProjectsSearch(data))
    yield put(fetchProjectsSearchSuccess())

  } catch(error) {
    console.log(error)
    yield put(fetchProjectsSearchError(error))
  }
}

function* postHierarchies({ payload }) {
  try {
    yield put(postHierarchiesStart())
    const id = yield select(projectIdSelector)
    const postRequest = post('project_hierarchies', payload)
    yield call(postRequest, `/api/fulcrum/projects/${id}/hierarchy`)
    yield put(closeDialog())
    yield put(postHierarchiesSuccess())
    yield put(fetchHierarchiesAction(parseInt(id)))
  } catch(error) {
    console.log(error)
    yield put(postHierarchiesError(error))
  }
}

function* watchOpenDialog(){
  yield takeLatest(OPEN_DIALOG, handleOpenDialog)
}

function* watchUpdateHierarchyType(){
  yield takeLatest(UPDATE_HIERARCHY_TYPE, handleUpdateHierarchyType)
}

function* watchFetchHierarchies(){
  yield takeLatest(FETCH_HIERARCHIES, fetchHierarchies)
}

function* watchFetchProjectsSearch(){
  yield takeLatest(FETCH_PROJECTS_SEARCH, fetchProjectsSearch)
}

function* watchPostHierarchies(){
  yield takeLatest(POST_HIERARCHIES, postHierarchies)
}

function* loadSagas() {
  yield all([
    fork(watchOpenDialog),
    fork(watchUpdateHierarchyType),
    fork(watchFetchHierarchies),
    fork(watchFetchProjectsSearch),
    fork(watchPostHierarchies)
  ])
}

export default loadSagas
